/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { select, call, put, all, take } from 'redux-saga/effects';

import { Branch } from 'src/components/types';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import { BuildStatusCountsMap } from 'src/types';
import { urls } from 'src/urls/commit';
import { authRequest } from 'src/utils/fetch';
import { short12Hash } from 'src/utils/short-hash';

import { LOAD_BRANCHES, LOAD_MAIN_BRANCH } from '../actions';
import { branch as branchSchema } from '../schemas';
import { getAllBranches, getMainBranch } from '../selectors';

export function createCommitStatusMapper(statuses: BuildStatusCountsMap) {
  return (branch: Branch) => {
    const status = statuses[short12Hash(branch.target.hash)];
    return {
      ...branch,
      status_counts: status && status.status_counts,
    };
  };
}

export function* loadBranchesStatusWorker() {
  // @ts-ignore
  const allBranches = yield select(getAllBranches);
  const repoFullSlug: string = yield select(getCurrentRepositoryFullSlug);
  const url = urls.api.internal.commitsBuildStatuses(repoFullSlug);

  try {
    const request = authRequest(url, {
      method: 'POST',
      body: allBranches
        // @ts-ignore TODO: fix noImplicitAny error here
        .map(branch => `commits=${branch.target.hash}`)
        .join('&'),
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });

    const response: Response = yield call(fetch, request);

    if (response.ok) {
      // @ts-ignore
      const statuses = yield response.json();

      if (Object.keys(statuses).length === 0) {
        return;
      }

      const updatedBranches = allBranches.map(
        createCommitStatusMapper(statuses)
      );

      // normalizr will handle this action
      yield put({
        type: 'branches/update-branches-with-build-status',
        payload: updatedBranches,
        meta: {
          schema: [branchSchema],
        },
      });
    }
  } catch {
    // Silently fail for now
  }
}

export function* loadBranchesStatusWatcher() {
  while (true) {
    // @ts-ignore
    const mainBranch = yield select(getMainBranch);
    const actions = [LOAD_BRANCHES.SUCCESS];

    if (!mainBranch) {
      actions.push(LOAD_MAIN_BRANCH.SUCCESS);
    }

    yield all(actions.map(action => take(action)));
    yield* loadBranchesStatusWorker();
  }
}
